import React, { useState } from 'react';
import { API } from '../App';
import axios from 'axios';
import { FileText, Loader2, CheckCircle } from 'lucide-react';

const DeudorApplicationForm = ({ user, onSubmitted }) => {
  const [form, setForm] = useState({
    nombre_completo: user?.name || '',
    documento: '',
    direccion: '',
    telefono: '',
    monto_deseado: '',
    meses_plazo: '',
    ingresos_totales: '',
    tipo_contrato: 'indefinido'
  });
  const [saving, setSaving] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nombre_completo || !form.documento || !form.monto_deseado) return;
    setSaving(true);
    try {
      await axios.post(`${API}/deudor/apply`, form, { withCredentials: true });
      setSubmitted(true);
      if (onSubmitted) onSubmitted();
    } catch (err) {
      alert(err.response?.data?.detail || 'Error al enviar solicitud');
    } finally {
      setSaving(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-[#0f1724] flex items-center justify-center p-4">
        <div className="bg-[#1a2332] border border-[#2a3444] rounded-2xl p-8 max-w-md w-full text-center">
          <CheckCircle className="w-16 h-16 mx-auto mb-4 text-emerald-400" />
          <h1 className="text-2xl font-bold text-white mb-2">Solicitud Enviada</h1>
          <p className="text-gray-400">Tu solicitud de préstamo será revisada por un administrador. Te notificaremos cuando sea aprobada.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0f1724] flex items-center justify-center p-4" data-testid="deudor-application-form">
      <div className="bg-[#1a2332] border border-[#2a3444] rounded-2xl p-8 max-w-lg w-full">
        <div className="text-center mb-6">
          <FileText className="w-12 h-12 mx-auto mb-3 text-[#D4AF37]" />
          <h1 className="text-2xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
            Solicitud de Préstamo
          </h1>
          <p className="text-sm text-gray-400 mt-1">Completa tus datos para solicitar un préstamo</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {[
            { key: 'nombre_completo', label: 'Nombre Completo *', type: 'text' },
            { key: 'documento', label: 'Número de Identificación *', type: 'text' },
            { key: 'telefono', label: 'Número de Teléfono', type: 'tel' },
            { key: 'direccion', label: 'Dirección', type: 'text' },
            { key: 'monto_deseado', label: 'Monto Deseado *', type: 'number' },
            { key: 'meses_plazo', label: 'Meses Aproximados para Pagar', type: 'number' },
            { key: 'ingresos_totales', label: 'Ingresos Totales Mensuales', type: 'number' },
          ].map(f => (
            <div key={f.key}>
              <label className="text-sm text-gray-400 mb-1 block">{f.label}</label>
              <input type={f.type} value={form[f.key]}
                onChange={e => setForm({...form, [f.key]: e.target.value})}
                className="w-full bg-[#141b2d] border border-[#2a3444] text-white rounded-lg px-3 py-2.5 text-sm focus:border-[#D4AF37] outline-none"
                data-testid={`deudor-${f.key}`} />
            </div>
          ))}
          <div>
            <label className="text-sm text-gray-400 mb-1 block">Tipo de Contrato</label>
            <select value={form.tipo_contrato} onChange={e => setForm({...form, tipo_contrato: e.target.value})}
              className="w-full bg-[#141b2d] border border-[#2a3444] text-white rounded-lg px-3 py-2.5 text-sm">
              <option value="indefinido">Indefinido</option>
              <option value="fijo">Término Fijo</option>
              <option value="prestacion_servicios">Prestación de Servicios</option>
              <option value="independiente">Independiente</option>
              <option value="otro">Otro</option>
            </select>
          </div>

          <button type="submit" disabled={saving}
            className="w-full bg-[#D4AF37] text-[#141b2d] py-3 rounded-lg font-semibold hover:bg-[#c29d2e] transition-colors disabled:opacity-50 flex items-center justify-center gap-2 mt-6"
            data-testid="submit-deudor-app">
            {saving && <Loader2 className="w-4 h-4 animate-spin" />}
            Enviar Solicitud
          </button>
        </form>
      </div>
    </div>
  );
};

export default DeudorApplicationForm;
